<template>
  <transition name="mobile" appear>
    <div class="menu-mobile">
      <div class="menu-mobile__wrapper">
        <div class="menu-mobile__container">
          <router-link
            v-if="$route.name !== 'home'"
            :to="{ name: 'home' }"
            class="button button--border my-2 w-100"
            @click.native="$emit('close')"
          >
            <span class="button__text">Volver al inicio</span>
          </router-link>
          <router-link
            v-if="!current_step && $route.name !== 'schedule-summary'"
            :to="{ name: 'schedule-service' }"
            class="button button--white my-2 w-100"
            @click.native="$emit('close')"
          >
            <span class="button__text">Agendar hora</span>
          </router-link>
          <button class="button button--delete my-2 w-100" @click="logoutUser">
            <i class="button__icon material-icons">power_settings_new</i>
            <span class="button__text">Salir</span>
          </button>
          <a
            v-if="site.label"
            class="menu-mobile__external site-external"
            :href="site.url"
            target="_blank"
            rel="noopener"
            @click="$emit('close')"
          >
            {{ site.label }} <i class="material-icons">exit_to_app</i>
          </a>
        </div>

        <contact-phones class="contact-phone--menu" />
      </div>
    </div>
  </transition>
</template>

<script>
import ContactPhones from '@/components/ContactPhones';

import { mapState } from 'vuex';

export default {
  name: 'AppMobile',
  props: {
    site: {
      type: Object,
      default: null,
    },
  },
  components: {
    ContactPhones,
  },
  computed: {
    ...mapState(['current_step']),
  },
  methods: {
    logoutUser() {
      this.$emit('close');
      this.$store
        .dispatch('logoutUser')
        .then(() => this.$router.push({ name: 'login' }))
        .catch(() => {
          this.$notify({
            group: 'general',
            type: 'error',
            title: 'Ha ocurrido un error',
            text: 'No hemos podido desconectar tu cuenta',
          });
        });
    },
  },
};
</script>
